/**
 * Locale-aware number/date formatting. Arabic defaults to LATIN digits and the
 * GREGORIAN calendar because that is what DMI's broadcast graphics use; both
 * are overridable per call (`numberingSystem: 'arab'`, `calendar: 'islamic'`).
 * Pinning them explicitly keeps output stable across ICU versions.
 */
const BCP47 = { en: 'en-GB', ar: 'ar-AE' };

function tag(locale) {
  return BCP47[locale] || locale || 'en-GB';
}

export function formatNumber(value, locale = 'en', opts = {}) {
  return new Intl.NumberFormat(tag(locale), { numberingSystem: 'latn', ...opts }).format(value);
}

export function formatDate(date, locale = 'en', opts = {}) {
  return new Intl.DateTimeFormat(tag(locale), {
    calendar: 'gregory',
    numberingSystem: 'latn',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...opts,
  }).format(date instanceof Date ? date : new Date(date));
}

export function formatRelativeTime(value, unit, locale = 'en') {
  return new Intl.RelativeTimeFormat(tag(locale), { numeric: 'auto' }).format(value, unit);
}

export default { formatNumber, formatDate, formatRelativeTime };
